import styled from 'styled-components';

export const Container = styled.div`
  height: 100vh;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FrameContainer = styled.div`
  /* border-top-color: #ffa200;
  border-top-style: solid;
  border-top-width: 10px; */
  padding: 40px;
  display: flex;
  gap: 14px;
  flex-direction: column;
  background-color: white;
  border-radius: 20px;
  width: 90vh;

  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 6px; /*largura da barra de rolagem*/
  }
  ::-webkit-scrollbar-thumb {
    /*barra de rolagem*/
    background-color: gray;
    border-radius: 4px;
  }
  ::-webkit-scrollbar-track {
    /*barra total*/
    background-color: transparent;
  }

  @media only screen and (max-width: 500px) {
    padding: 40px 24px;
    height: 100%;
    border-radius: unset;
  }
`;
